import React, { useEffect, useState } from "react";
import { Modal, Spinner, Table } from "react-bootstrap";
import { isAuthenticated } from "../../auth/helper/auth";
import { API } from "../../backend";
import { UserT } from "../../types/model";
import {
  deleteHttpHandler,
  getHttpHandler,
  putHttpHandler,
} from "../../utils/httpHandler";
import { ReactComponent as AddImg } from "../../assets/add.svg";
import { ReactComponent as ManageUsersImg } from "../../assets/manageUsers.svg";
import { ReactComponent as DeleteImg } from "../../assets/delete.svg";
import { ReactComponent as EditImg } from "../../assets/edit.svg";
import { ReactComponent as Error } from "../../assets/error.svg";
import "./ManageUsers.css";
import { userRoles } from "../../utils/data";

const ManageUsers = () => {
  const [users, setUsers] = useState<UserT[]>([]);
  const [userLoading, setUserLoading] = useState<boolean>(false);
  const [updatePassShow, setUpdatePassShow] = useState<boolean>(false);
  const [updatingPass, setUpdatingPass] = useState<boolean>(false);
  const [updatePassUserId, setUpdatePassUserId] = useState<string>("");
  const [errorMess, setErrorMess] = useState<string>("");
  const [passwords, setPasswords] = useState<{
    password: string;
    confirmPassword: string;
  }>({
    password: "",
    confirmPassword: "",
  });
  const [isDeleting, setIsDeleting] = useState<[string, boolean]>(["", false]);

  const getAllUsers = async () => {
    setUserLoading(true);
    try {
      const allusers: UserT[] = await getHttpHandler({
        url: `${API}/users/${isAuthenticated()?.user._id}`,
        idToken: isAuthenticated()?.token,
      });
      setUsers(allusers);
      setUserLoading(false);
    } catch (error) {
      setUserLoading(false);
      console.log(error);
    }
  };

  const updatePassword = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();

    if (!passwords.password) {
      return setErrorMess("Password is required!");
    }

    if (passwords.password.length < 6) {
      return setErrorMess("Password must be at least 6 characters!");
    }

    if (!passwords.confirmPassword) {
      return setErrorMess("Confirm your password!");
    }

    if (passwords.confirmPassword !== passwords.password) {
      return setErrorMess("Passwords do not match!");
    }

    setUpdatingPass(true);
    try {
      const updatedUser = await putHttpHandler({
        url: `${API}/user/update/password/${isAuthenticated()?.user._id}`,
        idToken: isAuthenticated()?.token,
        body: {
          password: passwords.password,
          _id: updatePassUserId,
        },
      });
      setUpdatingPass(false);
      setUpdatePassShow(false);
      setErrorMess("");
      setPasswords({ password: "", confirmPassword: "" });
      setUpdatePassUserId("");
      getAllUsers();
    } catch (error) {
      setUpdatingPass(false);
      setErrorMess("Something went wrong!!!");
    }
  };

  const deleteUser = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    userId: string
  ) => {
    e.preventDefault();
    setIsDeleting([userId, true]);
    try {
      const del = await deleteHttpHandler({
        url: `${API}/user/${userId}/${isAuthenticated()?.user._id}`,
        idToken: isAuthenticated().token,
      });
      setIsDeleting([userId, false]);
      getAllUsers();
    } catch (error) {
      setIsDeleting([userId, false]);
      console.error(error);
    }
  };

  useEffect(() => {
    getAllUsers();
  }, []);

  return (
    <div className="manage-user">
      <Modal
        className="manage-user-modal"
        show={updatePassShow}
        onHide={() => {
          setUpdatePassShow(false);
          setPasswords({ password: "", confirmPassword: "" });
          setUpdatePassUserId("");
          setErrorMess("");
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3 className="label-text">Enter Password</h3>
          <input
            onChange={(e) =>
              setPasswords({ ...passwords, password: e.target.value })
            }
            value={passwords.password}
            type="password"
            name="password"
          />
          <h3 className="label-text">Confirm Password</h3>
          <input
            onChange={(e) =>
              setPasswords({ ...passwords, confirmPassword: e.target.value })
            }
            value={passwords.confirmPassword}
            type="password"
            name="confirmPassword"
          />
          {errorMess && (
            <h2 className="errorMessage">
              <Error className="errorIcon" />
              {errorMess}
            </h2>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="action-btn white-action-btn"
            onClick={(e) => {
              e.preventDefault();
              setUpdatePassShow(false);
              setPasswords({ password: "", confirmPassword: "" });
              setUpdatePassUserId("");
              setErrorMess("");
            }}
          >
            Cancel
          </button>
          <button
            className="action-btn"
            onClick={updatePassword}
            disabled={updatingPass}
          >
            {updatingPass ? "Updating Password..." : "Update Password"}
          </button>
        </Modal.Footer>
      </Modal>
      <div className="header-div">
        <h1 className="title">
          <ManageUsersImg className="title-icon" />
          Manage Users
        </h1>
        {/* <div className="manage-btns">
          <button onClick={(e) => {e.preventDefault()}}>
            Add New Category <AddImg />
          </button>
        </div> */}
      </div>

      {userLoading ? (
        <Spinner animation="border" />
      ) : (
        <Table responsive borderless className="user-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Gender</th>
              <th>State</th>
              <th>Update Password</th>
              <th>Delete</th>
              {/* <th>Edit</th> */}
            </tr>
          </thead>
          <tbody>
            {users?.map((user) => (
              <tr key={user._id}>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>{userRoles[user.role]}</td>
                <td>{user.gender}</td>
                <td>{user.state}</td>
                <td>
                  <button
                    className="action-btn"
                    onClick={(e) => {
                      e.preventDefault();
                      setUpdatePassShow(true);
                      setUpdatePassUserId(user._id);
                    }}
                  >
                    Update Password <EditImg />
                  </button>
                </td>
                <td>
                  <button
                    disabled={isDeleting[0] === user._id && isDeleting[1]}
                    className="action-btn delete-btn"
                    onClick={(e) => deleteUser(e, user._id)}
                  >
                    {isDeleting[0] === user._id && isDeleting[1]
                      ? "Deleting..."
                      : "Delete"}{" "}
                    <DeleteImg />
                  </button>
                </td>
                {/* <td>
                  <button className="action-btn" onClick={() => {}}>
                    Update <EditImg />
                  </button>
                </td> */}
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default ManageUsers;
